import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { CTABand } from "../components/bits";
import { ARTICLES } from "../content/pages";

export default function Insights() {
  return (
    <>
      <Seo path="/insights" title="Insights" description="Plain-language reads on smart labels: what they are, how Bluetooth and cellular architectures differ, and how to choose." />
      <section className="border-b border-border bg-brand-surface">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <h1 className="max-w-3xl text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">Insights</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-slate md:text-lg">
            Short, honest reads for people evaluating smart labels. No gated PDFs, no doom CTAs.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <div className="grid gap-6 md:grid-cols-2">
          {ARTICLES.map((a) => (
            <Link key={a.slug} to={`/insights/${a.slug}`} data-testid={`insights-card-${a.slug}`}
              className="group rounded-sm border border-border bg-white p-8 transition-colors duration-150 hover:border-primary/50">
              <p className="font-mono text-xs text-brand-slate">{a.date} · {a.readingTime} read</p>
              <h2 className="mt-3 text-xl font-semibold text-brand-navy group-hover:text-primary">{a.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-brand-slate">{a.description}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                Read article <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </section>
      <CTABand />
    </>
  );
}
